module.exports = __webpack_public_path__ + "static/media/stats.eac4759b.svg";